export const MATCH_CHANGE_STORAGE_KEY = 'dohockey:match-change';

export function assertMatchRevision(expected: string | undefined, latest: unknown): string {
  const actual = latest && typeof latest === 'object' && 'updated_at' in latest ? latest.updated_at : null;
  if (!expected || expected !== actual) {
    throw Object.assign(new Error('Match data changed'), { code: 'MATCH_CHANGED' });
  }
  return expected;
}

export function isMatchConflict(error: unknown): boolean {
  return error instanceof Error && (
    ('code' in error && error.code === 'MATCH_CHANGED') ||
    error.message.includes('WORKLOAD: De wedstrijdinstellingen zijn gewijzigd.')
  );
}

/** Other tabs receive only an invalidation hint; the API remains authoritative. */
export function notifyOtherMatchTabs(matchId: string): void {
  try {
    localStorage.setItem(MATCH_CHANGE_STORAGE_KEY, JSON.stringify({ matchId, nonce: Math.random() }));
  } catch { /* Storage may be disabled. Preflight and server checks still apply. */ }
}

export function changedMatchId(value: string | null): string | undefined {
  try {
    const data = JSON.parse(value || 'null');
    return typeof data?.matchId === 'string' ? data.matchId : undefined;
  } catch { return undefined; }
}
